import React from "react";
import { ITableUI } from "src/Tables/TableTemplate/tableTemplate";
import GroupTableUI from "../DetailedPortfolio/GroupTableUI";
import { ICoveredCallPortfolioTableReport } from "src/Interfaces/portfolioGroups";

const visibleHeaderNames = new Set([
  "BuyInstrumentName",
  "BuyStrikePrice",
  "BuyContractSize",
  "BuyCount",
  "BuyBaseAssetEquivalent",
  "SellInstrumentName",
  "SellStrikePrice",
  "SellContractSize",
  "SellCount",
  "SellBaseAssetEquivalent",
]);

const columnWidthPercentages: Record<string, number> = {
  BuyInstrumentName: 12,
  SellInstrumentName: 12,
  BuyStrikePrice: 10,
  SellStrikePrice: 10,
  BuyContractSize: 8,
  SellContractSize: 8,
  BuyCount: 9,
  SellCount: 9,
  BuyBaseAssetEquivalent: 11,
  SellBaseAssetEquivalent: 11,
};

const getBasketGroupHeaderStyle = (
  groupName: string,
): React.CSSProperties | undefined =>
  groupName.includes("خرید")
    ? { backgroundColor: "#ebf9ee" }
    : groupName.includes("فروش")
      ? { backgroundColor: "#ffe7e6" }
      : undefined;

const ImbalanceCoveredCallPortfolioTableUI: React.FC<
  ITableUI<ICoveredCallPortfolioTableReport>
> = (props) => {
  const reports = React.useMemo(
    () => ({
      ...props.reports,
      translatedHeaders: props.reports.translatedHeaders.filter((header) =>
        visibleHeaderNames.has(header.headerName),
      ),
    }),
    [props.reports],
  );

  return (
    <GroupTableUI
      {...props}
      reports={reports}
      tableBoxClassName="!w-[872px] !max-w-full !max-h-none !overflow-x-visible !overflow-y-visible [&_.MuiTable-root]:!table-fixed"
      groupHeaderStyle={getBasketGroupHeaderStyle}
      columnWidthPercentages={columnWidthPercentages}
    />
  );
};

export default ImbalanceCoveredCallPortfolioTableUI;
